export const wpSetting = ({ setting, defaultValue, getter, setter, ...rest }) => {
	const key = `wp.post_meta._omapi_${setting}`;
	/**
	 * Get the value of this setting from the campaign's post meta.
	 *
	 * @returns {unknown} The value of the setting.
	 */
	function get() {
		const value = this.$get(`campaign.${key}`, defaultValue);
		return getter ? getter.call(this, value, key) : value;
	}
	return {
		get,
		set(value) {
			value = setter ? setter.call(this, value, key, get.bind(this)) : value;
			this.updateCampaignValue({
				campaignId: this.id,
				key,
				value,
				...rest,
			});
		},
	};
};

export const featureMap = [
	{
		slug: 'campaigns',
		title: 'All Campaign Types',
		description: 'Lightbox popups, floating bars, fullscreen welcome mats, slide-ins and more!',
		free: true,
	},
	{
		slug: 'page-level-targeting',
		title: 'Page Level Targeting',
		description: 'Use behavior personalization to display page-specific campaigns on your website.',
		free: true,
	},
	{
		slug: 'wpforms',
		title: 'WPForms',
		description: 'Build Smarter Forms and Surveys with WPForms',
		plugin: {
			title: 'WPForms',
			slug: 'wpforms-lite/wpforms.php',
		},
	},
	{
		slug: 'google-analytics',
		title: 'Google Analytics for WordPress',
		description:
			'Properly connect your site to <a href="#">Google Analytics</a> to make data-driven decisions, no coding needed.',
		plugin: {
			title: 'Google Analytics Dashboard Plugin for WordPress by MonsterInsights',
			slug: 'google-analytics-for-wordpress/googleanalytics.php',
		},
	},
	{
		slug: 'seo',
		title: 'All in One SEO',
		description:
			'Powerful toolkit to improve your <a href="#">SEO rankings</a> and uncover new growth opportunities.',
		plugin: {
			title: 'All-in-One SEO Pack',
			slug: 'all-in-one-seo-pack/all_in_one_seo_pack.php',
		},
	},
	{
		slug: 'social-proof',
		title: 'TrustPulse',
		description:
			'Leverage the true power of <a href="#">social proof</a> to increase site conversions by up to 15%!',
		plugin: {
			title: 'TrustPulse',
			slug: 'trustpulse-api/trustpulse.php',
		},
	},
	{
		slug: 'landing-pages',
		title: 'SeedProd Website Theme Builder',
		description: "Create High Converting Landing Pages & Websites. 100's of Templates.",
		plugin: {
			title: 'Website Builder by SeedProd',
			slug: 'coming-soon/coming-soon.php',
		},
	},
	{
		slug: 'pushengage',
		title: 'Push Notifications',
		description: 'Send personalized push notifications to visitors with PushEngage.',
		plugin: {
			title: 'PushEngage',
			slug: 'pushengage/main.php',
		},
	},
	{
		slug: 'split-test',
		featureId: 'ab-testing',
		title: 'A/B Split Testing',
		description: 'Eliminate the guesswork by testing your different content in your campaigns.',
	},
	{
		slug: 'exit-intent',
		title: 'Exit-Intent® Targeting',
		description: "Personalize your campaigns based on your visitor's behavior to maximize conversions.",
	},
	{
		slug: 'yesno',
		featureId: 'yesno-buttons',
		title: 'Yes / No Multi-Step Campaigns ',
		description: 'Create multi-step campaigns to boost traffic and grow your email list.',
	},
	{
		slug: 'coupon-wheel-campaigns',
		title: 'Gamified Coupon Wheel',
		description: 'Create interactive spin-a-wheel games to instantly multiply sales and conversions.',
		usage: 'retail_ecommerce',
	},
	{
		slug: 'content-locker',
		title: 'Content Locker',
		description: 'Grow your email list fast by locking your most in-demand content on your website.',
		usage: 'blog_media',
	},
	{
		slug: 'onsite-targeting',
		title: 'OnSite Retargeting & Follow Up Campaigns',
		description: 'Reduce abandonment and boost sales by customizing promotions for returning visitors.',
	},
];
